<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title *ngIf="!isTestemunho"
      >{{'Pedido de ' | translate}}{{'oracao' | nomenclatura | async}}</ion-title
    >
    <ion-title *ngIf="isTestemunho">{{'Testemunho' | nomenclatura | async}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content padding>
  <div class="gradient-extendido"></div>
  <ion-card *ngIf="oracao.id">
    <ion-grid>
      <ion-row class="ion-row-bord">
        <ion-col class="remove-border top-card-all">
          <ion-item>
            <ion-avatar slot="start">
              <img src="{{oracao.pessoa.foto | image:' '}}" />
            </ion-avatar>

            <ion-label>
              <h2 class="nome-usuario">{{oracao.pessoa.nome}}</h2>
              <p class="dias">{{ oracao.data | dateFormat:"mediaHora" }}</p>
            </ion-label>
          </ion-item>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col class="remove-border">
          <ion-item>
            <p class="pedido" [innerHTML]="oracao.pedido | safeHtml: 'html'"></p>
          </ion-item>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card>
</ion-content>
